"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _Record2;

var Blog =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(Blog, _Record);

  function Blog(props) {
    (0, _classCallCheck2.default)(this, Blog);

    if (props[_constants.ATTACHED_STYLESHEETS]) {
      props[_constants.ATTACHED_STYLESHEETS] = props[_constants.ATTACHED_STYLESHEETS].reduce(function (acc, stylesheet) {
        return acc.set(stylesheet.id, stylesheet);
      }, (0, _immutable.OrderedMap)());
    }

    if (props[_constants.COMMENT_NOTIFICATION_EMAILS]) {
      props[_constants.COMMENT_NOTIFICATION_EMAILS] = props[_constants.COMMENT_NOTIFICATION_EMAILS].reduce(function (acc, email) {
        return acc.push(email);
      }, (0, _immutable.List)());
    }

    if (props[_constants.PUBLIC_ACCESS_RULES]) {
      var listMembership = props[_constants.PUBLIC_ACCESS_RULES].find(function (rules) {
        return rules.type === 'LIST_MEMBERSHIP';
      });

      if (listMembership) {
        props[_constants.PUBLIC_ACCESS_RULES] = listMembership.ids.reduce(function (acc, id) {
          return acc.push(id);
        }, (0, _immutable.List)());
      } else {
        props[_constants.PUBLIC_ACCESS_RULES] = props[_constants.PUBLIC_ACCESS_RULES].reduce(function (acc, id) {
          return acc.push(id);
        }, (0, _immutable.List)());
      }
    }

    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Blog).call(this, props));
  }

  return Blog;
}((0, _immutable.Record)((_Record2 = {
  absoluteUrl: null,
  allowComments: null,
  ampBodyColor: null,
  ampBodyFont: null,
  ampBodyFontSize: null,
  ampCustomCss: null,
  ampHeaderBackgroundColor: null,
  ampHeaderColor: null,
  ampHeaderFont: null,
  ampHeaderFontSize: null,
  ampLinkColor: null,
  ampLogoAlt: null,
  ampLogoHeight: null,
  ampLogoSrc: null,
  ampLogoWidth: null,
  analyticsPageId: null,
  attachedStylesheets: null,
  captchaAfterDays: null,
  captchaAlways: null,
  categoryId: null,
  closeCommentsOlder: null,
  commentDateFormat: null,
  commentFormGuid: null,
  commentMaxThreadDepth: null,
  commentModeration: null,
  commentNotificationEmails: null,
  commentShouldCreateContact: null,
  commentVerificationText: null,
  created: null,
  createdDateTime: null,
  dailyNotificationEmailId: null,
  defaultGroupStyleId: null,
  defaultNotificationFromName: null,
  defaultNotificationReplyTo: null,
  deletedAt: null,
  description: null,
  domain: null,
  domainWhenPublished: null,
  emailApiSubscriptionId: null,
  enableGoogleAmpOutput: null,
  htmlFooter: null,
  htmlFooterIsShared: null,
  htmlHead: null,
  htmlHeadIsShared: null,
  htmlKeywords: null,
  htmlTitle: null,
  id: null,
  instantNotificationEmailId: null,
  itemLayoutId: null,
  itemTemplateIsShared: null,
  itemTemplatePath: null,
  language: null,
  listingLayoutId: null,
  listingTemplatePath: null,
  liveDomain: null,
  monthFilterFormat: null,
  monthlyNotificationEmailId: null,
  name: null,
  portalId: null,
  postHtmlFooter: null,
  postHtmlHead: null,
  postsPerListingPage: null,
  postsPerRssFeed: null,
  publicTitle: null,
  publishDateFormat: null,
  resolvedDomain: null,
  rootUrl: null,
  showSocialLinkFacebook: null,
  showSocialLinkLinkedin: null,
  showSocialLinkTwitter: null,
  showSummaryInEmails: null,
  showSummaryInListing: null,
  showSummaryInRss: null,
  siteId: null,
  slug: null,
  socialAccountTwitter: null,
  subscriptionContactsProperty: null,
  subscriptionFormGuid: null,
  subscriptionListsByType: null,
  updated: null,
  updatedDateTime: null,
  urlBase: null,
  useFeaturedImageInSummary: null,
  usesDefaultTemplate: null,
  weeklyNotificationEmailId: null
}, (0, _defineProperty2.default)(_Record2, _constants.PUBLIC_ACCESS_RULES, null), (0, _defineProperty2.default)(_Record2, _constants.PUBLIC_ACCESS_RULES_ENABLED, null), _Record2), _constants.BLOG));

exports.default = Blog;
module.exports = exports.default;